export default __webpack_public_path__ + "f5ffc809bf17dd73382a397bebbae73e.svg";